import { Button } from '@aqarmap/aqarmap-ui';
import Modal from '~/components/Modal';
import { useTranslation } from 'react-i18next';

const MarketListingTypeModal = ({
  onSelectPrimary,
  onSelectResale,
  isLoading,
}: {
  onSelectPrimary: () => void;
  onSelectResale: () => void;
  isLoading: boolean;
}) => {
  const { t } = useTranslation('app');

  return (
    <Modal
      modalKey="marketListingTypeModal"
      title={t('marketListingTypeTitle')}
    >
      <div className="flex flex-col gap-3x pb-3x">
        <p className="text-body_2 text-gray__dark_2">
          {t('marketListingTypeDescription')}
        </p>
        <Button
          variant="primary"
          size="medium"
          className="w-full rounded-[26px]"
          onClick={onSelectPrimary}
          isLoading={isLoading}
          disabled={isLoading}
        >
          {t('primary')}
        </Button>
        <Button
          variant="secondary"
          size="medium"
          className="w-full rounded-[26px]"
          onClick={onSelectResale}
          disabled={isLoading}
        >
          {t('resale')}
        </Button>
      </div>
    </Modal>
  );
};

export default MarketListingTypeModal;
